import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { MaterialTypeService } from '../proxy/general/controllers/material-type.service';
import { ConsumableService } from '../proxy/general/controllers/consumable.service';

FieldBuilder.setNamespace('General');

export const MATERIAL_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .foreignKey('materialTypeId', 'Entity.MaterialType', MaterialTypeService)
    .required()
    .displayFromNested('materialType.name')
    .sortBy('materialType.name')
    .build(),
  FieldBuilder
    .foreignKey('consumableId', 'Entity.Consumable', ConsumableService)
    .required()
    .displayFromNested('consumable.name')
    .sortBy('consumable.name')
    .hideInChildForms()
    .build(),
];

export const MATERIAL_CONFIG = {
  entityName: 'Material',
  localizationKey: 'General::Entity.Material',
  fields: MATERIAL_FIELDS,
  permission: 'GeneralConsumables.Materials',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Consumables + MENU_NAME_SUFFIX,
};
